export const data = {
    greet: {
        pt: "Olá",
        eng: "Hello There"
    },
    intro:{
        pt: "O meu nome é João Guedes",
        eng: "My name is João Guedes"
    },
    titles:{
        pt: ["Mestrado em Engenharia de Gestão e Sistemas de Informação", "Engenharia de Software", "Ciência de Dados", "Gestão de Projetos", "Cibersegurança", "Hacking Ético", "DevOps", "Utilizador Avançado de Unix"],
        eng: ["Master's in Management Engineering and Information Systems", "Software Engineering", "Data Science", "Project Management", "CyberSecurity", "Ethical Hacking", "DevOps", "Unix Poweruser"]
    },
    p1:{
        pt:"Adoro código, criar e resolver problemas e este é o meu website pessoal e portfolio de projetos",
        eng:"I love to code, create and problem-solve and this is my personal Website and projects portfolio"
    },
    p2:{
        pt:"Acompanhe o meu projeto mais recente, estou muito orgulhoso dele",
        eng:"Check out my latest work, I'm really proud of it"
    },
    btnProj:{
        pt:"Projeto",
        eng:"Latest Work"
    },
    btnContact:{
        pt:"Vamos Falar",
        eng:"Let's Talk"
    },
    latest:"clab"
};

